import ReactDom from 'react-dom';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useCallbackFn } from '@/hooks';
import styles from './index.less';

interface ContextMenuOption {
  list: any[];
  reference: HTMLElement;
  render: (ary: any[]) => JSX.Element | JSX.Element[] | React.ReactFragment;
}

const ContextMenu: React.FC<{
  option: ContextMenuOption;
  onRef: (ins: { show: (opt: ContextMenuOption) => void }) => void;
}> = (props) => {
  const elRef = useRef({} as HTMLDivElement);
  const [option, setOption] = useState<ContextMenuOption>(props.option);
  const [showFlag, setShowFlag] = useState<boolean>(false);
  const [list, setList] = useState<any[]>([]);
  useEffect(() => {
    setList(option.list);
  }, [option.list]);

  const styleObj = useMemo(() => {
    const { reference } = option;
    const { top, left } = reference.getBoundingClientRect();
    return {
      bottom: `${document.body.clientHeight - top + 8}px`,
      left: `${left}px`,
      display: showFlag ? 'inline-block' : 'none',
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [option.reference, showFlag]);

  const methods = {
    close: () => {
      setShowFlag(false);
    },
    show: (opt: ContextMenuOption) => {
      setOption(opt);
      setShowFlag(true);
    },
  };

  const domClick = useCallbackFn((e: MouseEvent) => {
    if (!elRef.current.contains(e.target as Node)) {
      methods.close();
    } else {
      setTimeout(() => {
        methods.close();
      }, 0);
    }
  });

  props.onRef(methods);

  useEffect(() => {
    document.addEventListener('click', domClick);
    return () => {
      document.removeEventListener('click', domClick);
    };
  }, [domClick]);

  return (
    <div className={styles.context_menu} style={styleObj} ref={elRef}>
      {option.render(list)}
    </div>
  );
};

const $$dialog = (() => {
  let ins: any;
  return (option: ContextMenuOption) => {
    if (!ins) {
      const el = document.createElement('div');
      document.body.appendChild(el);
      ReactDom.render(<ContextMenu option={option} onRef={(i) => (ins = i)} />, el);
    }
    ins.show(option);
    return ins;
  };
})();

export default $$dialog;
